import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  IconButton,
  Link,
  Grid,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import DeleteIcon from "@mui/icons-material/Delete";
import React from "react";
import PlansModal from "./PlansModal";
import DeletePrompt from "./DeletePrompt";

function Cart(props) {
  const plans = props.plans;

  const addItem = (index) => {
    var newConnections = [...props.connectionsState.connections];
    newConnections.push({
      planName: plans[index].planName,
      planDescriptor: plans[index].planDescriptor,
      address: "",
      moveInFlag: "",
      nmi: "",
      concessionFlag: "",
      lifeSupportFlag: "",
      solarFlag: "",
      connectionId: "",
    });
    props.connectionsState.setConnections(newConnections);
    handleClosePlans();
    props.activeStepState.setActiveStep(1);
  };

  const removeItem = (index) => {
    let newConnections = props.connectionsState.connections;
    props.handleDeleteConnection(newConnections[index].connectionId);
    newConnections.splice(index, 1);
    props.connectionsState.setConnections(newConnections);
    props.connectionsState.handleUpdateConnections();
  };

  const [openPlans, setOpenPlans] = React.useState(false);
  const [planIndex, setPlanIndex] = React.useState(0);
  // const [planName, setPlanName] = React.useState("");

  // const handleOpenPlans = () => setOpenPlans(true);
  const handleClosePlans = () => setOpenPlans(false);

  const [openDeletePrompt, setOpenDeletePrompt] = React.useState(false);

  return (
    <>
      <Card sx={{ minWidth: "250px" }} m={2} mx={"auto"}>
        <CardHeader
          // action={<Button onClick={handleOpenPlans}>+ Add Connection</Button>} /// TEMP remove add connection in cart
          title="Your Connections"
          data-cy="cart-add-connection"
        />
        <Typography variant="subtitle1" sx={{ mb: 3, ml: 2 }}>
          Summary of your connection(s)
        </Typography>

        <CardContent sx={{ p: 2 }}>
          {props.cart.map((item, index) => {
            return (
              <div key={index}>
                <Box
                  sx={{ borderTop: 1, borderColor: "grey.300", p: 2 }}
                  width={"100"}
                >
                  <Grid
                    container
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Grid item sx={{ flexGrow: 1 }}>
                      <Typography variant="h5" gutterBottom component="div">
                        {plans[item.planName].shortName}
                        <span
                          style={{
                            color: "#FF127F",
                            fontSize: "30px",
                          }}
                        >
                          .
                        </span>
                      </Typography>
                    </Grid>

                    <Grid item mx={"auto"}>
                      <IconButton
                        aria-label="delete"
                        onClick={() => {
                          setPlanIndex(index);
                          setOpenDeletePrompt(true);
                          // removeItem(index);
                        }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Grid>
                  </Grid>
                  <Typography gutterBottom component="div" mb={2}>
                    {item.connectionAddress}
                  </Typography>
                  <Typography variant="h6" gutterBottom component="div" mb={2}>
                    {item.planPrice} pa incl. GST
                  </Typography>
                  <Divider my={3} flexItem />
                  {item.bpidLinks.map((bpid) => {
                    return (
                      <Link
                        key={bpid.name}
                        mt={2}
                        gutterBottom
                        variant="caption"
                        display={"block"}
                        href={bpid.href}
                        target="_blank"
                      >
                        {bpid.name}
                      </Link>
                    );
                  })}
                </Box>
              </div>
            );
          })}
        </CardContent>
      </Card>
      <PlansModal
        open={openPlans}
        handleClose={handleClosePlans}
        addItem={addItem}
        plans={plans}
      />
      <DeletePrompt
        open={openDeletePrompt}
        index={planIndex}
        // planName={planName}
        removeItem={removeItem}
        handleDeleteConnection={props.handleDeleteConnection}
        handleClose={(e) =>
          setOpenDeletePrompt((openDeletePrompt) => !openDeletePrompt)
        }
      />
    </>
  );
}

export default Cart;
